export default __webpack_public_path__ + "static/media/Group 5328.660f37f6.png";